var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"tile":""}},[_c('v-card-title',{staticClass:"grey lighten-2"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }